import { QueryClient } from "@tanstack/react-query";
import { mv2RetryDelay, shouldRetryMv2Query } from "@/features/_mv2/makeQueryClient";
import { WE_AGENT_REPORT_QUERY_KEY } from "./weAgentReportQueryApi";

export const weAgentReportQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: shouldRetryMv2Query,
      retryDelay: mv2RetryDelay,
    },
  },
});

export function prefetchWeAgentReport(date) {
  return weAgentReportQueryClient.prefetchQuery({
    queryKey: [WE_AGENT_REPORT_QUERY_KEY, date],
    queryFn: () =>
      import("./weAgentReportQueryApi").then((m) =>
        m.fetchWeAgentReportFromApi(date)
      ),
  });
}
